import LOGO from './logo.png';
import QR_CODE from './qr-code.png';

export const IMAGES = {
  LOGO,
  QR_CODE,
};
